import { render, staticRenderFns } from "./layerPanel.vue?vue&type=template&id=aded4ba8&scoped=true"
import script from "./layerPanel.vue?vue&type=script&lang=js"
export * from "./layerPanel.vue?vue&type=script&lang=js"
import style0 from "./layerPanel.vue?vue&type=style&index=0&id=aded4ba8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aded4ba8",
  null
  
)

export default component.exports